import { setUser } from '@sentry/angular';
import {
  getStoredAccessToken,
  getUserRoleIdFromAccessToken,
} from '../../auth-session.util';
import { isSentryEnabled } from './sentry-init';

/** Uses JWT `user_role_id` only — no email or display name. */
export function syncSentryUserFromStoredToken(): void {
  if (!isSentryEnabled()) {
    return;
  }
  if (!getStoredAccessToken()) {
    clearSentryUser();
    return;
  }
  const userRoleId = getUserRoleIdFromAccessToken();
  if (userRoleId == null) {
    clearSentryUser();
    return;
  }
  setUser({ id: String(userRoleId) });
}

export function clearSentryUser(): void {
  if (!isSentryEnabled()) {
    return;
  }
  setUser(null);
}
